var _rect, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccountDataDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 209,
    viewBox: "0 0 446 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.745,
    y: 9.74504,
    width: 320.674,
    height: 198.112,
    rx: 9.25496,
    fill: "url(#paint0_linear_3246_31856)",
    fillOpacity: 0.5,
    stroke: "url(#paint1_linear_3246_31856)",
    strokeWidth: 1.49007
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6719,
    y: 20.6719,
    width: 60.6977,
    height: 176.257,
    rx: 5,
    fill: "#42448C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 40.5156,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 63.8613,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#818AE8",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6758,
    y: 52.1885,
    width: 46.6905,
    height: 5.83632,
    rx: 1.21208,
    fill: "#686EC3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3246_31856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 42.0615,
    width: 240.041,
    height: 66.9587,
    rx: 5,
    transform: "rotate(-7.91665 180 42.0615)",
    fill: "url(#paint2_linear_3246_31856)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.684,
    y: 42.5783,
    width: 238.829,
    height: 65.7466,
    rx: 4.39396,
    transform: "rotate(-7.91665 180.684 42.5783)",
    stroke: "#818AE8",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 194.949,
    y: 57.8389,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 194.949 57.8389)",
    fill: "#686EC3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 198.43,
    y: 82.8662,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 198.43 82.8662)",
    fill: "#686EC3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 196.691,
    y: 70.3525,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 196.691 70.3525)",
    fill: "#686EC3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 271.281,
    y: 47.2236,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 271.281 47.2236)",
    fill: "#686EC3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 274.758,
    y: 72.252,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 274.758 72.252)",
    fill: "#686EC3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 59.7373,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 273.02 59.7373)",
    fill: "#686EC3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 347.609,
    y: 36.6104,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 347.609 36.6104)",
    fill: "#686EC3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 351.094,
    y: 61.6367,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 351.094 61.6367)",
    fill: "#686EC3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 349.352,
    y: 49.123,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    transform: "rotate(-7.91665 349.352 49.123)",
    fill: "#686EC3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3246_31856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 118,
    width: 240.041,
    height: 66.9587,
    rx: 5,
    fill: "url(#paint3_linear_3246_31856)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.606,
    y: 118.606,
    width: 238.829,
    height: 65.7466,
    rx: 4.39396,
    stroke: "#818AE8",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 135.687,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 160.954,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 207.633,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 135.687,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 160.954,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 284.699,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 135.687,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 160.954,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 361.766,
    y: 148.32,
    width: 60.6418,
    height: 6.31686,
    rx: 1.21208,
    fill: "#686EC3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3246_31856)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3246_31856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 113.254,
    width: 66.4941,
    height: 66.4941,
    rx: 5,
    transform: "rotate(-8 12 113.254)",
    fill: "url(#paint4_linear_3246_31856)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6845,
    y: 113.77,
    width: 65.2821,
    height: 65.2821,
    rx: 4.39396,
    transform: "rotate(-8 12.6845 113.77)",
    stroke: "#5CC9FA",
    strokeWidth: 1.21208,
    strokeDasharray: "5 5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8061 128.705C48.7152 128.057 48.1166 127.606 47.4691 127.697C46.8217 127.788 46.3707 128.387 46.4617 129.034L48.0542 140.366L36.7225 141.958C36.0751 142.049 35.624 142.648 35.715 143.295C35.806 143.943 36.4046 144.394 37.052 144.303L48.3837 142.71L49.9763 154.042C50.0673 154.689 50.6659 155.14 51.3133 155.049C51.9607 154.958 52.4118 154.36 52.3208 153.712L50.7282 142.381L62.0599 140.788C62.7073 140.697 63.1584 140.099 63.0674 139.451C62.9764 138.804 62.3778 138.353 61.7304 138.444L50.3987 140.036L48.8061 128.705Z",
    fill: "#5CC9FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3246_31856",
    x: 168.641,
    y: 0.640625,
    width: 267.695,
    height: 120.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.34902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3246_31856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3246_31856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3246_31856",
    x: 183,
    y: 109,
    width: 262.039,
    height: 88.959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.34902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3246_31856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3246_31856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3246_31856",
    x: 0.648438,
    y: 95.6465,
    width: 95.8047,
    height: 95.8076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.34902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3246_31856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3246_31856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3246_31856",
    x: 0.648438,
    y: 95.6465,
    width: 95.8047,
    height: 95.8076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.34902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3246_31856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3246_31856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3246_31856",
    x1: 54.4914,
    y1: 204.607,
    x2: 371.676,
    y2: 15.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3D8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3246_31856",
    x1: 94.4894,
    y1: 4.24757,
    x2: 142.533,
    y2: 223.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3C88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3246_31856",
    x1: 180,
    y1: 103.304,
    x2: 354.711,
    y2: -28.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3246_31856",
    x1: 195,
    y1: 179.243,
    x2: 369.711,
    y2: 47.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3246_31856",
    x1: 12,
    y1: 174.072,
    x2: 84.5842,
    y2: 158.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363680"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccountDataDark);
export default __webpack_public_path__ + "static/media/noAccountDataDark.c6696a705d7c13c963083a0cd2871f0c.svg";
export { ForwardRef as ReactComponent };